import { render, staticRenderFns } from "./VaChip.vue?vue&type=template&id=4af4a962&"
import script from "./VaChip.vue?vue&type=script&lang=js&"
export * from "./VaChip.vue?vue&type=script&lang=js&"
import style0 from "./VaChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports